module.exports = __webpack_public_path__ + "img/skinxs-black-icon.d7ad00be.svg";